import {
    lazyHasCurrentlyDisplayedView,
    lazyGetCurrentlyDisplayedViewId,
    lazyGetSavedCalendarView,
    SaveCalendarViewConfig,
} from 'owa-save-calendar-view-data';

export default function getSelectedSaveView(): SaveCalendarViewConfig | undefined {
    if (getIsSavedViewSelected()) {
        const getCurrentlyDisplayedViewId = lazyGetCurrentlyDisplayedViewId.tryImportForRender();
        const getSavedCalendarView = lazyGetSavedCalendarView.tryImportForRender();

        if (getCurrentlyDisplayedViewId && getSavedCalendarView) {
            return getSavedCalendarView(getCurrentlyDisplayedViewId());
        }
    }

    return undefined;
}

function getIsSavedViewSelected(): boolean {
    const hasCurrentlyDisplayedView = lazyHasCurrentlyDisplayedView.tryImportForRender();
    if (hasCurrentlyDisplayedView?.()) {
        return true;
    }

    return false;
}
